<template>
  <TabsLayout>
    <ElTabPane name="daily-list" label="报表任务列表"></ElTabPane>
    <ElTabPane name="daily-form" label="新建报表任务" v-if="$route.name === 'daily-form'"></ElTabPane>
    <ElTabPane name="daily-task-records" label="发送任务记录" v-if="$route.name === 'daily-task-records'"></ElTabPane>
  </TabsLayout>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'
export default {
  components: {
    TabsLayout
  },
  name: 'daily-push'
}
</script>
<style lang="scss" scoped>
</style>
